import { Observable } from 'rxjs';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Injectable } from '@angular/core';

import {AppEditRowComponent} from "./app-edit-row.component";
import {FormGroup} from "@angular/forms";

interface confirmData {
  title?: string,
  message?: string
  item?: any
  editFields?: any
}

@Injectable()
export class AppEditRowService {

  constructor(private dialog: MatDialog) { }

  public edit(data:confirmData = {}): Observable<any> {
    data.title = data.title || 'Confirmar';
    data.message = data.message || 'Estás seguro?';
    data.item = data.item || null;
    data.editFields = data.editFields || null;
    console.log("APP EDIT ROW", data)
    let dialogRef: MatDialogRef<AppEditRowComponent>;
    dialogRef = this.dialog.open(AppEditRowComponent, {
      width: '100%',
      disableClose: true,
      data: {title: data.title, message: data.message, item: data.item, editFields: data.editFields}
    });
    return dialogRef.afterClosed();
  }
}
